export class TreeUtils {

  public static TRAVERSE_ALGORITHM = Object.freeze({
    INORDER: 'inorder'
  })

  public traverse<T>(treeRoot: T, childPropertyName: string,
                     visitor: (visitedNode: T, depth?: number, siblings?: T[], root?: T) => boolean | any,
                     algorithm: 'inorder' = 'inorder'): boolean {
    if (typeof visitor !== 'function') {
      throw new Error('Visitor must be a function')
    }

    let terminated = false
    const unprocessedChildren: T[] = [treeRoot]
    let currentDepth = 0
    const unprocessedChildrenCount: { [depth: number]: number } = { 0: unprocessedChildren.length }
    let currentNode: T
    let currentNodeChildren: T[]
    while (unprocessedChildren.length > 0 && !terminated) {
      // TODO [GitHub Issue]: use shift and change depth calculation
      currentNode = unprocessedChildren.pop()

      currentNodeChildren = Array.isArray(currentNode[childPropertyName]) ? currentNode[childPropertyName] : []
      for (let i = currentNodeChildren.length - 1; i >= 0; i--) {
        terminated = false === visitor(currentNodeChildren[i], currentDepth + 1, currentNodeChildren, treeRoot)
        if (terminated) {
          break
        }
      }
      Array.prototype.push.apply(unprocessedChildren, currentNodeChildren)

      currentDepth = this.calculateTraverseDepth(currentDepth, unprocessedChildrenCount, currentNodeChildren.length)
    }
    return !terminated
  }

  public reduce<T>(treeRoot: T, childPropertyName: string,
                   callBackFn: (
                            previousValue: any, visitedNode: T, depth?: number,
                            siblings?: T[], root?: T
                          ) => any,
                   initialValue?: any
  ): any {
    let previousValue = initialValue
    this.traverse<T>(treeRoot, childPropertyName, (visitedNode, depth, siblings, root) => {
      previousValue = callBackFn(previousValue, visitedNode, depth, siblings, root)
    })
    return previousValue
  }

  public every<T>(treeRoot: T, childPropertyName: string,
                  testFn: (
                            visitedNode: T, depth?: number, siblings?: T[], root?: T
                        ) => boolean): boolean {
    let everyIsTrue = true
    this.traverse<T>(treeRoot, childPropertyName, (visitedNode, depth, siblings, root) => {
      everyIsTrue = everyIsTrue && true === testFn(visitedNode, depth, siblings, root)
      if (!everyIsTrue) {
        return false
      }
    })
    return everyIsTrue
  }

  public some<T>(treeRoot: T, childPropertyName: string,
                 testFn: (
                          visitedNode: T,
                          depth?: number,
                          siblings?: T[],
                          root?: T
                        ) => boolean): boolean {
    let someAreTrue = false
    this.traverse<T>(treeRoot, childPropertyName, (visitedNode, depth, siblings, root) => {
      someAreTrue = testFn(visitedNode, depth, siblings, root)
      if (someAreTrue === true) {
        return false
      }
    })
    return someAreTrue
  }

  private calculateTraverseDepth(currentDepth, unprocessedChildrenCount, currentNodeChildrenCount) {
    const nextDepth = currentDepth + 1
    unprocessedChildrenCount[currentDepth]--
    unprocessedChildrenCount[nextDepth] = (unprocessedChildrenCount[nextDepth] || 0) + currentNodeChildrenCount
    if (unprocessedChildrenCount[nextDepth] > 0) {
      currentDepth++
    } else if (unprocessedChildrenCount[currentDepth] === 0) {
      currentDepth--
    }
    return currentDepth
  }
}



// WEBPACK FOOTER //
// ./node_modules/@mprep/shared/lib/helpers/tree-utils/tree-utils.ts